import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { LotDetailContext } from '../../Contexts/LotDetailContext';
import { Section } from '../../Types/Section';
import { QIR } from '../../Types/QIR';

export function LotDetailSection({ name, icon, title, titleSuffix, component }: Section) {
    const { t } = useTranslation();
    const { lotDetail } = useContext(LotDetailContext);

    const hasOpenQIRMSQirs = (qirs: QIR[]) => {
        if (qirs.length === 0) {
            return false;
        }

        return qirs.some(q => q.status === null || q.status === "Open");
    };

    const getAccordionHeaderClass = () => {
        let warningClassName = "warning";

        switch (name) {
            case "warnings":
                return lotDetail.warnings.length > 0 ? warningClassName : "";
            case "qualities":
                return lotDetail.qualities?.some(q => q.isOffspec) ? warningClassName : "";
            case "labresults":
                return lotDetail.labResults.some(l => l.isOffspec) ? warningClassName : "";
            case "QIRMSqirs":
                return hasOpenQIRMSQirs(lotDetail.qirs) ? warningClassName : "";
            case "qirs":
                return lotDetail.qirs.length > 0 ? warningClassName : "";
            default:
                return "";
        }
    };

    return (
        <Accordion.Item id={`${name}-${lotDetail.summary.lotNumber}-section`} eventKey={name}>
            <Accordion.Header className={getAccordionHeaderClass()}>
                {icon &&
                    <FontAwesomeIcon icon={icon} className="me-3" />}
                {`${t<string>(title)}${titleSuffix ? ` (${titleSuffix})` : ''}`}
            </Accordion.Header>
            <Accordion.Body>
                {component}
            </Accordion.Body>
        </Accordion.Item>
    );
}
